<template>
   <span v-if="isSAR" class="icon-saudi_riyal_bold_new"></span>
   <span v-else>{{ symbol }}</span>
</template>

<script>
export default {
   name: 'CurrencySymbol',
   props: {
      symbol: {
         type: String,
         default: 'ر.س',
      },
   },
   computed: {
      isSAR() {
         return ['ر.س', 'SR'].includes(this.symbol);
      },
   },
};
</script>
